import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { FaArrowRight, FaComments, FaChalkboardTeacher, FaUsers } from 'react-icons/fa';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import { getRevealProps, staggerContainer, staggerItem, defaultViewport } from '../motion/scrollMotion';
import './ServiceDetailPage.css';

const formats = [
  {
    icon: <FaChalkboardTeacher />,
    title: 'Topic Walkthroughs',
    desc: 'A senior consultant walks your team through a specific topic — ISO 27001 readiness, ransomware-resilient backups, secure SDLC rollout — scoped to your actual environment rather than a generic slide deck.',
  },
  {
    icon: <FaUsers />,
    title: 'Team Briefings',
    desc: 'A live session for your engineering, IT, or leadership team to ask questions directly about a finding, a framework, or a decision you are weighing — no recording, no audience, just your team and ours.',
  },
  {
    icon: <FaComments />,
    title: 'Executive Briefings',
    desc: 'A board- or leadership-level session translating a recent assessment, incident, or compliance requirement into business risk and a recommended path forward.',
  },
];

const WebinarsPage = () => (
  <div className="svc-page">
    <PageNavbar />

    <section className="svc-hero">
      <div className="svc-hero-glow" />
      <div className="svc-container">
        <motion.div className="svc-hero-text" style={{ maxWidth: '42rem' }} {...getRevealProps('fadeUp')}>
          <span className="svc-eyebrow">Webinars & Sessions</span>
          <h1 className="svc-hero-title">Live Sessions, Scheduled Around You.</h1>
          <p className="svc-hero-desc">
            We do not run a public webinar calendar with canned dates — most of the value in these
            sessions comes from tailoring them to your team's actual questions. Tell us what you
            need covered, and we will schedule a session directly.
          </p>
          <div className="svc-hero-actions">
            <Link to="/contact" className="svc-btn svc-btn-primary">
              Request a Session <FaArrowRight />
            </Link>
            <Link to="/blog" className="svc-btn svc-btn-ghost">
              Read Our Articles Instead
            </Link>
          </div>
        </motion.div>
      </div>
    </section>

    <section className="svc-section">
      <div className="svc-container">
        <header className="svc-section-head">
          <span className="svc-section-tag">Formats</span>
          <h2 className="svc-section-title">Three Ways We Do This</h2>
        </header>

        <motion.div
          className="svc-feature-grid"
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
          variants={{ ...staggerContainer, visible: { transition: { staggerChildren: 0.1 } } }}
          style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}
        >
          {formats.map((f) => (
            <motion.article className="svc-feature-card" key={f.title} variants={staggerItem}>
              <div className="svc-feature-icon">{f.icon}</div>
              <h3 className="svc-feature-title">{f.title}</h3>
              <p className="svc-feature-desc">{f.desc}</p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>

    <section className="svc-cta">
      <div className="svc-container">
        <motion.div className="svc-cta-card" {...getRevealProps('scaleUp')}>
          <h2 className="svc-cta-title">Want to schedule a session?</h2>
          <p className="svc-cta-desc">
            Tell us the topic and who needs to be in the room — we respond to every inquiry within
            one business day.
          </p>
          <div className="svc-cta-actions">
            <Link to="/contact" className="svc-btn svc-btn-primary">
              Get In Touch <FaArrowRight />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>

    <Footer />
  </div>
);

export default WebinarsPage;
